import Swiper from 'swiper';

const TextMediaSlider = () => {
    const init = () => {
        const carousels = document.querySelectorAll('.text-media__carousel.swiper');

        if (!carousels.length) return;


        carousels.forEach((carousel) => {
            const slides = carousel.querySelectorAll('.swiper-slide');
            const prevButton = carousel.querySelector('.swiper-pagination__button-prev');
            const nextButton = carousel.querySelector('.swiper-pagination__button-next');

            const swiper = new Swiper(carousel, {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: false,
                loop: slides.length > 1,
                autoHeight: true,
            });

            if (prevButton && nextButton) {
                const updateButtonStates = () => {
                    if (slides.length <= 1) {
                        prevButton.disabled = true;
                        nextButton.disabled = true;
                        prevButton.classList.add('swiper-button-disabled');
                        nextButton.classList.add('swiper-button-disabled');
                        return;
                    }

                    prevButton.disabled = !swiper.params.loop && swiper.isBeginning;
                    nextButton.disabled = !swiper.params.loop && swiper.isEnd;
                    prevButton.classList.toggle('swiper-button-disabled', prevButton.disabled);
                    nextButton.classList.toggle('swiper-button-disabled', nextButton.disabled);
                };

                prevButton.addEventListener('click', () => swiper.slidePrev());
                nextButton.addEventListener('click', () => swiper.slideNext());
                updateButtonStates();
                swiper.on('slideChange', updateButtonStates);
            }
        });
    };

    return {
        init
    };
};

export default TextMediaSlider;
